import { render, staticRenderFns } from "./TenancyLedger.vue?vue&type=template&id=4c7b2b80&scoped=true&"
import script from "./TenancyLedger.vue?vue&type=script&lang=js&"
export * from "./TenancyLedger.vue?vue&type=script&lang=js&"
import style0 from "./TenancyLedger.vue?vue&type=style&index=0&id=4c7b2b80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b2b80",
  null
  
)

export default component.exports